<template>
	<div class="" style="height: 100%;width: 99%;font-family:'宋体'">
		<!-- 123 -->
		<el-row :gutter="20" style="margin-top: 1%;">
			<el-col :span="9" :style="pieheight">
				<pieChart1></pieChart1>
			</el-col>
			<el-col :span="15" :style="pieheight">
				<barChart></barChart>
			</el-col>
		</el-row>
		<el-row :gutter="20"  >
			<el-col :span="24" :style="tableHeight">
				<line-chart></line-chart>
			</el-col>
		</el-row>

	</div>
</template>

<script>
	import echarts from 'echarts';
	// import './utils/china.js'
	import {
		mapGetters
	} from 'vuex';
	// import {
	// 	getReportStatisticsCount,
	// 	getCollegeStatisticsCount
	// } from "api/edu/administrators/index";
	// import panThumb from 'components/PanThumb';
	import pieChart2 from './pieChart2';
	import pieChart1 from './pieChart1';
	import barChart from './barChart';
	import lineChart from './lineChart';
	// import countTo from 'vue-count-to';
	// import todoList from 'components/TodoList';

	export default {
		name: 'dashboard-editor',
		components: {
			//panThumb,
			// countTo,
			pieChart2,
			pieChart1,
			lineChart,
			barChart
			// todoList
		},
		data() {
			return {
				statisticsData: {
					article_count: 0,
					// comment_count: 102400,
					// latest_article: [],
					// month_article_count: 28,
					// pageviews_count: 1024,
				},
				// totalNum: 10000,
				day:new Date(),
			}
		},
		computed: {
			...mapGetters([
				'name',
				'avatar',
				'roles'
			])
		},
		methods: {
			//时间格式化函数，此处仅针对yyyy-MM-dd hh:mm:ss 的格式进行格式化
			dateFormat(time) {
				var date = new Date(time);
				var year = date.getFullYear();
				/* 在日期格式中，月份是从0开始的，因此要加0
				 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
				 * */
				var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
				var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
				var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
				var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
				var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
				// 拼接
				// return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
				return year + "-" + month + "-" + day;
			},
			getHeight() {
				// console.log(window.innerHeight);
				this.pieheight = "height:"+ (window.innerHeight - 480)+'px';
				this.tableHeight = "height:"+ (window.innerHeight - 450)+'px';
				this.divheight = window.innerHeight - 165 + 'px'
			},
		},
		mounted() {
			let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
			this.timer = setInterval(() => {
				// _this.day = new Date(); // 修改数据date
			}, 1000);
			//this.getmap();
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		},
		created() { //创建完成（可以访问当前this实例）
			// console.log("132165465468")
			window.addEventListener('resize', this.getHeight);
			this.getHeight();
		},
		// destroyed() {
		// 	window.removeEventListener('resize', this.getHeight)
		// }
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.dashboard-editor-container {
		margin: 30px;

		.btn-group {
			margin-bottom: 60px;
		}
         .STYLE5 {
         	font-size: 40px;
         	font-family: "微软雅黑";
         	color: #fff;
         	text-align: center;
         }
		.box-card-header {
			position: relative;
			height: 160px;
		}

		.panThumb {
			z-index: 100;
			height: 150px;
			width: 150px;
			position: absolute;
			left: 0px;
			right: 0px;
			margin: auto;
		}

		.display_name {
			font-size: 30px;
			display: block;
		}

		.info-item {
			display: inline-block;
			margin-top: 10px;
			font-size: 14px;

			&:last-of-type {
				margin-left: 15px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/editor/index.vue